import React, {useEffect, useState} from "react"
import {Form, Modal, Select} from "antd"
import CustomSelect from "../../../components/CustomSelect"
import CustomButton from "../../../components/CustomButton"
import CustomInput from "../../../components/CustomInput"
import Notifications from "../../../helpers/Notifications"
import {useTranslation} from "react-i18next"
import {setFormErrors} from "../../../helpers/formErrors";
import {useDispatch, useSelector} from "react-redux";
import {reRegionActions} from "../ReRegion/store/actions";
import api from "./store/api"

const {Option} = Select

const ReCityChangeForm = (props) => {
    const {visible, setVisible, setRecord, record, changed} = props
    const regionList = useSelector(state => state.reRegionReducer.list)
    const [loading, setLoading] = useState(false)
    const [regions, setRegions] = useState([])
    const dispatch = useDispatch()
    const {t} = useTranslation(['common', 'valid', 'action'])
    const [form] = Form.useForm()

    const create = params => {
        action(api.create, params, changed, t('action:created'))
    }
    const update = params => {
        action(api.update, params, changed, t('action:updated'))
    }

    const action = (func, params, sucFunction, sucParams) => {
        setLoading(true)
        func(params)
            .then(res => sucFunction(res, sucParams))
            .catch(err => {
                setFormErrors(err, form)
            })
            .finally(() => setLoading(false))
    }

    useEffect(() => {
        if (visible) {
            if (regionList.length === 0) {
                dispatch(reRegionActions.getList())
            }
        }
    }, [visible])

    useEffect(() => {
        form.resetFields()
        if (record) {
            form.setFieldsValue({
                code: record.code,
                region: record.reRegionId,
                name: record.name
            })
        }
    }, [record])

    useEffect(() => {
        setRegions(regionList)
    }, [regionList])

    function handleChange(value) {
        const filtered = [...regionList.filter(n => n.name.toLowerCase().includes(value))]
        setRegions(filtered)
    }

    function handleCancel() {
        form.resetFields()
        setRecord(null)
        setVisible(false)
    }

    const save = () => {
        form.validateFields().then(values => {
            const updateValues = {
                id: record?.id,
                code: values.code,
                region: values.region,
                name: values.name.trim(),
                createDate: record?.createDate,
                isDeleted: record?.isDeleted
            }
            const previousValues = {
                id: record?.id,
                code: record?.code,
                region: record?.reRegionId,
                name: record?.name,
                createDate: record?.createDate,
                isDeleted: record?.isDeleted
            }
            if (JSON.stringify(updateValues) === JSON.stringify(previousValues))
                Notifications.errorNotice(t('valid:sameData'), null, 20)
            else
                record ? update(updateValues) : create(updateValues)
        })
    }

    return (
        <Modal
            destroyOnHidden
            footer={[
                <CustomButton
                    key="save"
                    loading={loading}
                    type="green"
                    onClick={save}
                >
                    {t('action:save')}
                </CustomButton>
            ]}
            title={record ? t('action:editRecord') : t('action:addRecord')}
            open={visible}
            width={900}
            onCancel={handleCancel}
        >
            <Form
                form={form}
                labelAlign="left"
                labelCol={{span: 6}}
                name="nsi-form"
                wrapperCol={{span: 17, offset: 1}}
            >
                <Form.Item
                    label={t('common:code')}
                    name="code"
                    rules={[
                        {
                            required: true,
                            whitespace: true,
                            message: t('valid:codeFilledBad'),
                            pattern: /^[1-9]\d{0,6}$/
                        }
                    ]}
                >
                    <CustomInput
                        disabled = {record}
                        placeholder={`${t('action:enter')} ${t('common:code').toLowerCase()}`}
                        readOnly={Boolean(record)}
                    />
                </Form.Item>
                <Form.Item
                    label={t('common:region')}
                    name="region"
                    rules={[{required: true}]}
                >
                    <CustomSelect
                        allowClear
                        showSearch
                        filterOption={false}
                        notFoundContent={null}
                        placeholder={`${t('action:choose')} ${t('common:region').toLowerCase()}`}
                        onSearch={handleChange}
                    >
                        {regions?.map(item => {
                            return (
                                <Option
                                    key={item.id}
                                    value={item.id}
                                >
                                    {item.name}
                                </Option>)
                        })}
                    </CustomSelect>
                </Form.Item>
                <Form.Item
                    label={t('common:title')}
                    name="name"
                    rules={[
                        {
                            required: true,
                            whitespace: true,
                            min: 3,
                            max: 200
                        }
                    ]}
                >
                    <CustomInput
                        maxLength={250}
                        placeholder={`${t('action:enter')} ${t('common:title').toLowerCase()}`}
                    />
                </Form.Item>
            </Form>
        </Modal>
    )
}
export default ReCityChangeForm
